




import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    components: {},
})
export default class CircleSpinner extends Vue {
    @Prop({ default: 'info' }) public variant!: 'info' | 'primary'
    @Prop({ default: 'medium' }) public size!: 'small' | 'medium' | 'large'

    public get classes() {
        return [`loader--${this.variant}`, `loader--${this.size}`]
    }
}
